export const sanatizeName = (name: string, length = 26): string => {
  if (name.length >= length) {
    name = name.substring(0, 8) + '...' + name.substring(name.length - 8)
  }
  return name
}
